import { useShowTooltip } from './useShowTooltip';
import { Typography, TypographyProps, Tooltip, TooltipProps } from '@mui/material';
import React, { useRef } from 'react';

type Props = Omit<TooltipProps, 'children'> & {
  label: React.ReactNode;
  labelProps?: TypographyProps;
};

export const MaybeTooltip = (props: Props): JSX.Element => {
  const { label, labelProps, ...tooltipProps } = props;
  const { sx: labelSx, ...restLabelProps } = labelProps || {};

  const textElementRef = useRef<HTMLElement>(null);
  const showTooltip = useShowTooltip(textElementRef, label);

  return (
    <Tooltip {...tooltipProps} disableHoverListener={!showTooltip}>
      <Typography
        // eslint-disable-next-line no-restricted-syntax
        sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', ...labelSx }}
        {...restLabelProps}
        ref={textElementRef}
      >
        {label}
      </Typography>
    </Tooltip>
  );
};
